import { formatSupabaseError } from './formatSupabaseError';
import { getDbSupabase } from './supabase';

export type AccountCreationChangeType =
  | 'submitted'
  | 'verified'
  | 'approved'
  | 'rejected'
  | 'edit'
  | 'nav_push';

export type AccountCreationChangeLogRow = {
  id: string;
  submission_id: string;
  changed_at: string;
  changed_by: string | null;
  change_type: AccountCreationChangeType;
  summary: string;
  before_json: unknown;
  after_json: unknown;
};

const TABLE = 'account_creation_change_log';

export async function fetchAccountCreationChangeLogs(
  submissionId: string,
): Promise<AccountCreationChangeLogRow[]> {
  const db = getDbSupabase('forms');
  const { data, error } = await db
    .from(TABLE)
    .select('id,submission_id,changed_at,changed_by,change_type,summary,before_json,after_json')
    .eq('submission_id', submissionId.trim())
    .order('changed_at', { ascending: false });
  if (error) throw new Error(formatSupabaseError(error));
  return (data ?? []).map((row) => {
    const r = row as Record<string, unknown>;
    return {
      id: String(r.id ?? ''),
      submission_id: String(r.submission_id ?? ''),
      changed_at: String(r.changed_at ?? ''),
      changed_by: r.changed_by == null ? null : String(r.changed_by),
      change_type: String(r.change_type ?? 'edit') as AccountCreationChangeType,
      summary: String(r.summary ?? ''),
      before_json: r.before_json ?? null,
      after_json: r.after_json ?? null,
    };
  });
}

export async function insertAccountCreationChangeLog(input: {
  submissionId: string;
  changedBy?: string | null;
  changeType: AccountCreationChangeType;
  summary: string;
  beforeJson?: unknown;
  afterJson?: unknown;
}): Promise<void> {
  const db = getDbSupabase('forms');
  const { error } = await db.from(TABLE).insert({
    submission_id: input.submissionId.trim(),
    changed_by: input.changedBy?.trim() || null,
    change_type: input.changeType,
    summary: input.summary.trim() || 'Updated',
    before_json: input.beforeJson ?? null,
    after_json: input.afterJson ?? null,
  });
  if (error) throw new Error(formatSupabaseError(error));
}
